import React from 'react';
import { FaMusic, FaRedoAlt } from 'react-icons/fa';
import HomeStreamEmbed from './HomeStreamEmbed.jsx';
import HomeStatusPill from './HomeStatusPill.jsx';
import { useT } from '../../../contexts/LocaleContext.jsx';

/**
 * Secondary performer card (Figma Z07 "BIGGEST CROWD" / Z08 "RANDOM PICK"):
 * 16:9 player, eyebrow label, name, live pill and the current song row.
 */
const HomePerformerCard = ({
  eyebrow,
  band,
  isLive = false,
  viewerCount = 0,
  embedUrl = null,
  currentSong = null,
  onOpen,
  onShuffle,
}) => {
  const t = useT();
  if (!band) return null;
  const headingId = `listener-home-card-${band.ID}`;

  return (
    <section className="listener-home-card listener-home-performer" aria-labelledby={headingId} data-testid="home-performer-card">
      <HomeStreamEmbed band={band} isLive={isLive} embedUrl={embedUrl} className="listener-home-performer-embed" />

      <div className="listener-home-performer-body">
        <span className="listener-home-eyebrow">{eyebrow}</span>
        <div className="listener-home-performer-title-row">
          <h2 id={headingId} className="listener-home-performer-name">
            <button type="button" className="listener-home-performer-link" onClick={onOpen}>
              {band.Name}
            </button>
          </h2>
          <HomeStatusPill isLive={isLive} viewerCount={viewerCount} />
        </div>

        <div className="listener-home-performer-song-row">
          {currentSong?.ArtworkURL ? (
            <img src={currentSong.ArtworkURL} alt="" className="listener-home-performer-cover" />
          ) : (
            <span className="listener-home-performer-cover listener-home-cover--empty" aria-hidden="true">
              <FaMusic />
            </span>
          )}
          <div className="listener-home-performer-song">
            <span className="listener-home-eyebrow">{t('home.currentSong')}</span>
            <span className="listener-home-performer-song-title">
              {currentSong ? (
                <>
                  {currentSong.Title}
                  {currentSong.Artist && (
                    <span className="listener-home-performer-song-artist">
                      {' · '}
                      {currentSong.Artist}
                      {/* The year is shown as-is, never locale-formatted ("2015", not "2,015"). */}
                      {currentSong.ReleaseYear ? ` · ${currentSong.ReleaseYear}` : null}
                    </span>
                  )}
                </>
              ) : (
                <span className="listener-home-performer-song-artist">
                  {isLive ? t('home.performer.nothingOnStage') : t('common.status.offline')}
                </span>
              )}
            </span>
          </div>
          {onShuffle && (
            <button type="button" className="listener-home-btn-outline listener-home-shuffle" onClick={onShuffle}>
              {t('home.performer.shuffle')} <FaRedoAlt className="rtl-keep" aria-hidden="true" />
            </button>
          )}
        </div>
      </div>
    </section>
  );
};

export default HomePerformerCard;
